up.compiler('.new-message-form', (element) => {

  up.util.task(() => {
    element.scrollIntoView({ block: 'end', behavior: 'smooth' })
  })

})
